module.exports = __webpack_public_path__ + "img/人力资源服务.9d72c64d.png";